import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a48i0fg8: FaireBrandEntity = {
  token: "b_a48i0fg8",
  type: "brand",
  name: "Selini New York",
  avatarUrl:
    "https://cdn.faire.com/fastly/2bb269f2841eb91c1daf6119c3423925b096d296aeaa1906e00da7c545ca9f03.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1cd59a25d37214d3027864c970f6c6fe2eb6a5910d60ac90aad3432c90b2da56.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2bb269f2841eb91c1daf6119c3423925b096d296aeaa1906e00da7c545ca9f03.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1cd59a25d37214d3027864c970f6c6fe2eb6a5910d60ac90aad3432c90b2da56.jpeg",
  location: "Wayne, NJ, USA",
  minimumOrderDollars: 109,
  rating: 4.8,
  reviewCount: 939,
  isTopShop: true,
  isInsider: true,
  description:
    "Selini NY is a leading fashion wholesaler based in the Northeast. We have been in business for over 30 years and carry over 6,000 products. We understand the difficulty in managing a business, so we work hard to focus on our retailers' needs. We offer low pricing, low minimums and high quality goods for you to supply your stores.\n\nThousands of boutique across North America rely on Selini NY's merchandise to stock their stores, and most if not all our customers stay with us long term. We live and breathe by the motto that the customer is king, and we do our best to meet all of our customers' expectations.\n\nWe ship all over the world and offer free shipping to orders shipping in the 48 contiguous states.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:14.814Z",
    importedBy: "entity-db-cli",
  },
};
